export const sampleUnitTypeProject1 = [
  { value: 'B', text: 'B - Bend' }, 
  { value: 'S', text: 'S - Segment' }
];